import { productIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

const ProductPrice_ = z.object({
  productId: productIdFormat.schema,
  sku: z.string().nullable(),
  priceInCents: z.number().int(),
  currency: z.string(),
});

export const ProductPrice: z.ZodType<ProductPrice> = ProductPrice_;
export interface ProductPrice extends z.infer<typeof ProductPrice_> {}

export const getScenarioProductPrices = {
  name: "getScenarioProductPrices" as const,
  input: z.object({ productIds: z.array(productIdFormat.schema) }),
  output: z.object({ products: z.array(ProductPrice) }),
};
